import { Loading } from 'components'
import React, { Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

const AdminApp = React.lazy(() => import('domains/admin/containers/app/app'))

const AppRoutes: React.FC = () => (
  <Suspense fallback={<Loading />}>
    <Router>
      <Switch>
        <Route path="/" component={AdminApp} />
      </Switch>
    </Router>
  </Suspense>
)
export default AppRoutes
